import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import MuiBox from '@mui/material/Box';
import React__default from 'react';

const ActionButtons = (_a) => {
    var { LeftComponent, RightComponent, rtl } = _a, rest = __rest(_a, ["LeftComponent", "RightComponent", "rtl"]);
    if (!LeftComponent && !RightComponent) {
        return null;
    }
    return (jsxs(MuiBox, Object.assign({ display: "flex", alignItems: "center", flexDirection: rtl ? 'row-reverse' : 'row', justifyContent: LeftComponent && RightComponent ? 'space-between' : LeftComponent ? 'flex-start' : 'flex-end', width: "100%" }, rest, { children: [LeftComponent && (jsx(MuiBox, Object.assign({ display: "flex", flexDirection: rtl ? 'row-reverse' : 'row', marginLeft: 2 }, { children: React__default.createElement(LeftComponent) }))), RightComponent && (jsx(MuiBox, Object.assign({ display: "flex", flexDirection: rtl ? 'row-reverse' : 'row' }, { children: React__default.createElement(RightComponent) })))] })));
};

export { ActionButtons as default };
//# sourceMappingURL=ActionButtons.js.map
